module.exports = __webpack_public_path__ + "img/bg_chaozhishangcheng_2_bg.c9becd5a.png";